var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CompButton',{attrs:{"placeholder":"選擇標籤","format":"{0}個標品","disabled":_vm.disabledBtn,"value":_vm.value.length},on:{"click":_vm.handleClickAdd,"remove":_vm.onRemove,"view":_vm.onViewItem}})}
var staticRenderFns = []

export { render, staticRenderFns }